module.exports = __webpack_public_path__ + "nc_static/media/user-profile.4eddf79f.svg";